export default __webpack_public_path__ + "static/media/Slide1.86ceba2b.PNG";